module.exports = __webpack_public_path__ + "static/blog-img10-568ea971541538d405c6355631cef45e.jpg";